<app-slide-in-modal #modal size="lg" [width]="importSuccess ? 95 : null">
  <ng-container title>
    @if (updating) {
      @if (proposalState === 'POLICY_CREATED') {
        <ng-container i18n>Modifier une police</ng-container>
      } @else {
        <ng-container i18n>Modifier une offre</ng-container>
      }
    } @else {
      @if (proposalState === 'POLICY_CREATED') {
        <ng-container i18n>Ajouter une police</ng-container>
      } @else {
        <ng-container i18n>Ajouter une offre</ng-container>
      }
    }
  </ng-container>
  <div [class.import-form-body]="importSuccess" body>
    <div *ngIf="loading" class="d-flex justify-content-center p-4">
      <div class="spinner-border" role="status"></div>
    </div>
    <form
      *ngIf="!loading"
      (ngSubmit)="submitProposal()"
      class="lty-form"
      [id]="formId"
    >
      <div class="modal-body">
        <div class="split-form-body">
          @if (proposalState === ProposalState.PROPOSAL_SAVED) {
            <div class="mb-16">
              <div class="form-subtitle flex-basis-100 mb-16" i18n>
                Importer une offre PDF
              </div>
              <button
                type="button"
                (click)="importInput.click()"
                [disabled]="importing"
                class="lty-btn lty-btn-primary import-btn"
              >
                <span
                  [style.visibility]="importing ? 'collapse' : 'visible'"
                  i18n
                  >Importer</span
                >
                @if (importing) {
                  <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                }
              </button>
              <input
                (change)="handleImport($event)"
                type="file"
                class="d-none"
                #importInput
              />
            </div>
            @if (importErrors?.length > 0) {
              <div class="import-result">
                <ul>
                  @for (error of importErrors; track error) {
                    <ol>
                      {{
                        error
                      }}
                    </ol>
                  }
                </ul>
              </div>
            }
          }

          <div class="form-subtitle flex-basis-100 mb-16" i18n>
            Informations sur l'offre
          </div>
          <ng-container [formGroup]="offerInformations">
            <div
              class="form-group flex-basis-50"
              *ngIf="proposalState === ProposalState.PROPOSAL_SAVED"
            >
              <label for="useremail" i18n
                >ID de l'offre (OID) <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                formControlName="offerNumber"
                [ngClass]="{
                  'is-invalid':
                    pstep1['offerNumber'].touched &&
                    pstep1['offerNumber'].errors,
                }"
              />
              <div
                *ngIf="
                  pstep1['offerNumber'].touched && pstep1['offerNumber'].invalid
                "
                class="invalid-feedback"
              >
                <div
                  *ngIf="
                    pstep1['offerNumber'].errors &&
                    pstep1['offerNumber'].errors['required']
                  "
                  i18n
                >
                  Le numéro de l'offre est requis.
                </div>
              </div>
            </div>
            <div class="form-group flex-basis-50">
              <label i18n
                >Type d'assurance <span class="text-danger">*</span></label
              >
              <select
                class="form-select form-control"
                [attr.disabled]="true"
                formControlName="insuranceType"
                [ngClass]="{
                  'is-invalid':
                    pstep1['insuranceType'].touched &&
                    pstep1['insuranceType'].errors,
                }"
              >
                <option value="" i18n></option>
                <option
                  *ngFor="let insuranceType of insuranceTypeListData"
                  [value]="insuranceType"
                >
                  {{ getInsuranceTypeLabel(insuranceType) }}
                </option>
              </select>
              <div
                *ngIf="
                  pstep1['insuranceType'].touched &&
                  pstep1['insuranceType'].invalid
                "
                class="invalid-feedback"
              >
                <div
                  *ngIf="
                    pstep1['insuranceType'].errors &&
                    pstep1['insuranceType'].errors['required']
                  "
                  i18n
                >
                  Le type d'assurance est requis.
                </div>
              </div>
            </div>
            <div class="form-group flex-basis-50">
              <label i18n
                >Date de début <span class="text-danger">*</span></label
              >
              <input
                type="date"
                class="form-control"
                [min]="minStartDate"
                formControlName="startDate"
                [ngClass]="{
                  'is-invalid':
                    pstep1['startDate'].touched && pstep1['startDate'].errors,
                }"
              />
              <div
                *ngIf="
                  pstep1['startDate'].touched && pstep1['startDate'].invalid
                "
                class="invalid-feedback"
              >
                <div
                  *ngIf="
                    pstep1['startDate'].errors &&
                    pstep1['startDate'].errors['required']
                  "
                  i18n
                >
                  La date de début est requise.
                </div>
              </div>
            </div>
            <div class="form-group flex-basis-50">
              <label i18n>Date de fin <span class="text-danger">*</span></label>
              <input
                type="date"
                class="form-control"
                formControlName="endDate"
                [ngClass]="{
                  'is-invalid':
                    pstep1['startDate'].touched && pstep1['startDate'].errors,
                }"
              />
              <div
                *ngIf="
                  (pstep1['endDate'].touched || pstep1['endDate'].dirty) &&
                  pstep1['endDate'].invalid
                "
                class="invalid"
              >
                <div
                  *ngIf="
                    pstep1['endDate'].errors &&
                    pstep1['endDate'].errors['required']
                  "
                  i18n
                >
                  End date is required.
                </div>
                <div *ngIf="pstep1['endDate'].errors?.['dateAfter']" i18n>
                  La date de fin ne peut pas être avant la date de début.
                </div>
              </div>
            </div>

            @if (showOfferSignatureDateField) {
              <div class="form-group flex-basis-50">
                <label for="offer-signature-date" i18n
                  >Date de signature de l'offre</label
                >
                <input
                  id="offer-signature-date"
                  type="date"
                  class="form-control"
                  formControlName="offerSignatureDate"
                />
              </div>
            }

            <div
              class="form-group flex-basis-50"
              *ngIf="proposalState === ProposalState.PROPOSAL_SAVED"
            >
              <label i18n>Mots clés</label>
              <tag-input
                placeholder="+"
                secondaryPlaceholder="Enter a new tag"
                formControlName="keyTag"
                i18n-secondaryPlaceholder="@@taginput"
                i18n-placeholder="@@taginputsecond"
              />
            </div>
          </ng-container>
          <ng-container [formGroup]="products">
            <div class="form-group flex-basis-50">
              <label i18n
                >Fréquence de paiement <span class="text-danger">*</span></label
              >
              <select
                class="form-control form-select"
                formControlName="periodicity"
                [ngClass]="{
                  'is-invalid':
                    pstep2['periodicity'].touched &&
                    pstep2['periodicity'].errors,
                }"
              >
                <option value="" i18n="@@selectperiod">
                  Choisir une périodicité
                </option>
                <option
                  *ngFor="let value of Periodicity"
                  [ngValue]="value"
                  i18n
                >
                  {{ getPeriodicityLabel(value) }}
                </option>
              </select>
              <div
                *ngIf="
                  pstep2['periodicity'].touched && pstep2['periodicity'].invalid
                "
                class="invalid-feedback"
              >
                <div
                  *ngIf="
                    pstep2['periodicity'].errors &&
                    pstep2['periodicity'].errors['required']
                  "
                  i18n
                >
                  La périodicité est requise
                </div>
              </div>
            </div>
          </ng-container>
          <div class="form-subtitle flex-basis-100 mb-16" i18n>
            Type de produit
          </div>
          <ng-container [formGroup]="products">
            <app-product-selection
              #productSelectionComponent
              [productForm]="products"
              [insuranceType]="offerInformations.controls.insuranceType.value"
              [partnerId]="products.value.partnerId"
              [agentId]="products.value.agent"
              [leadDetailsData]="leadDetailsData"
              [leadId]="leadId"
              (productSelectionChanged)="handleProductSelectionChange()"
            />
            <div class="form-group flex-basis-100">
              <label i18n>Périodicité des couvertures sur document</label>
              <div class="position-relative">
                <select
                  class="form-control"
                  formControlName="coversPeriodicity"
                >
                  <option
                    *ngFor="let value of Periodicity"
                    [ngValue]="value"
                    i18n
                  >
                    {{ getPeriodicityLabel(value) }}
                  </option>
                </select>
                <i class="bi bi-chevron-down edge-element"></i>
              </div>
            </div>

            <div class="form-subtitle flex-basis-100 mb-16" i18n>
              Spécificités
            </div>
            <div class="form-group flex-basis-50">
              <label i18n>Montant de la prime</label>
              <input class="form-control" formControlName="premiumAmount" />
            </div>
            <div class="form-group flex-basis-50">
              <label i18n>Montant total</label>
              <input class="form-control" formControlName="totalAmount" />
            </div>
          </ng-container>
          <ng-container *ngIf="proposalState === ProposalState.PROPOSAL_SAVED">
            <div class="form-subtitle flex-basis-100 mb-16" i18n>
              Avantages du produit
            </div>
            <div class="form-group flex-basis-100">
              <editor
                [formControl]="productBenefictsForm"
                plugins="anchor autolink charmap codesample emoticons link lists searchreplace table visualblocks wordcount"
                toolbar="undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link table | addcomment showcomments | spellcheckdialog a11ycheck | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat"
              />
              <div
                *ngIf="
                  productBenefictsForm.touched && productBenefictsForm.invalid
                "
                class="invalid-feedback"
              >
                <div
                  *ngIf="
                    productBenefictsForm.errors &&
                    productBenefictsForm.errors['required']
                  "
                  i18n
                >
                  Product benifits is required.
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="proposalState === ProposalState.PROPOSAL_SAVED">
            <div class="form-subtitle flex-basis-100 mb-16" i18n>
              Principales caractéristiques
            </div>
            <div class="form-group flex-basis-100">
              <editor
                [formControl]="keyFeatureForm"
                plugins="anchor autolink charmap codesample emoticons link lists searchreplace table visualblocks wordcount"
                toolbar="undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link table | addcomment showcomments | spellcheckdialog a11ycheck | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat"
              />
            </div>
          </ng-container>

          <div class="form-group flex-basis-100">
            <label class="file-label" i18n>Document d'offre</label>
            <div class="file alternate">
              <input
                type="file"
                id="file"
                class="file-input"
                (change)="onFileUpload($event)"
                multiple
              />
              <div class="upload-icon">
                <app-upload-cloud-icon
                  height="20px"
                  width="20px"
                  color="var(--gray-600)"
                />
              </div>
              <span
                ><span class="highlighted-text" i18n
                  >Cliquez pour télécharger
                </span>
                <ng-container i18n>ou glissez un fichier</ng-container></span
              >
            </div>
            <div *ngIf="files && files.length > 0" class="mt-28">
              <span class="mb-16 file-label" i18n>Documents téléchargés</span>
              <div
                class="uploaded-file-container mb-8"
                *ngFor="let uploadedFile of files; let i = index"
              >
                <div class="uploaded-file-element">
                  <app-file-icon
                    height="20px"
                    width="20px"
                    color="var(--gray-400)"
                  />
                  <div class="file-name">
                    <span>{{ uploadedFile.name }}</span>
                    <span>{{ uploadedFile.size | fileSize: 1 }}</span>
                  </div>
                  <app-check-circle-icon
                    height="16px"
                    width="16px"
                    color="var(--success-500)"
                  />
                </div>
                <app-trash-icon
                  class="clickable"
                  (click)="removeFile(i)"
                  height="24px"
                  width="24px"
                  color="var(--gray-400)"
                />
              </div>
            </div>
            <ng-container
              *ngIf="
                existingDocs &&
                existingDocs.length > 0 &&
                (!files || files.length === 0)
              "
            >
              <span class="mb-16 file-label mt-16" i18n
                >Anciens documents téléchargés</span
              >
              <div
                class="uploaded-file-container mb-8"
                *ngFor="let existingDoc of existingDocs; let i = index"
              >
                <div
                  class="uploaded-file-element clickable"
                  (click)="viewFile(existingDoc.url)"
                >
                  <app-file-icon
                    height="20px"
                    width="20px"
                    color="var(--gray-400)"
                  />
                  <div class="file-name">
                    <span>{{ getFileName(existingDoc.url) }}</span>
                  </div>
                  <app-check-circle-icon
                    height="16px"
                    width="16px"
                    color="var(--success-500)"
                  />
                </div>
                <app-trash-icon
                  class="clickable"
                  (click)="removeExistingDoc(i)"
                  height="24px"
                  width="24px"
                  color="var(--gray-400)"
                />
              </div>
            </ng-container>
          </div>

          <ng-container
            *ngIf="proposalState === ProposalState.POLICY_CREATED"
            [formGroup]="acceptedProposalFormGroup"
          >
            <div class="form-group flex-basis-100">
              <label i18n
                >Numéro de police <span class="text-danger">*</span></label
              >
              <input
                class="form-control"
                type="text"
                formControlName="policyId"
              />
            </div>
          </ng-container>

          @if (
            proposalState === ProposalState.PROPOSAL_SAVED &&
            cgaDocuments &&
            cgaDocuments.length > 0
          ) {
            <div class="form-subtitle flex-basis-100 mb-16" i18n>
              Documents CGA
            </div>
            <div class="form-group flex-basis-100 d-flex gap-3 flex-wrap">
              @for (doc of cgaDocuments; track doc) {
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    (change)="toggleDocument($event, doc)"
                    [value]="doc"
                    [id]="'check' + doc.id"
                    [checked]="isDocumentSelected(doc)"
                  />
                  <label class="form-check-label" [for]="'check' + doc.id">{{
                    doc.documentName
                  }}</label>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </form>
    @if (importSuccess) {
      <div class="imported-file-container">
        <pdf-viewer
          [src]="importedFileUrl"
          [render-text]="true"
          style="width: 100%; height: 80vh"
          [autoresize]="true"
        />
      </div>
    }
  </div>
  <div class="modal-submit-buttons" footer>
    <button
      type="button"
      class="lty-btn lty-btn-white ms-auto"
      (click)="closeModal()"
      i18n
    >
      Annuler
    </button>
    <button
      [attr.form]="formId"
      type="submit"
      [disabled]="!canSubmit()"
      class="lty-btn lty-btn-primary"
    >
      <ng-container *ngIf="updating" i18n>Sauvegarder</ng-container
      ><ng-container *ngIf="!updating" i18n>Ajouter</ng-container>
    </button>
  </div>
</app-slide-in-modal>
<app-pdf-viewer-modal #pdfViewer />
